import { Navigate, useParams } from "react-router-dom";
import { defaultLocale, isSupportedLocale } from "@/lib/i18n/portal";

function getResolvedLocale(value: string | undefined) {
  return value && isSupportedLocale(value) ? value : defaultLocale;
}

export function StoreLookupRedirectPage() {
  const { locale: routeLocale } = useParams();
  const locale = getResolvedLocale(routeLocale);

  return <Navigate to={`/${locale}/login`} replace />;
}
